export const logger = {
    error: (...error) => {
        console.log(...error);
    },

    info: (...params) => {
        console.log(...params);
    },

    debug: (...params) => {
        if ("development" === process.env.NODE_ENV) console.log(...params);
    },
};
